import { render, staticRenderFns } from "./RoundsTableView.vue?vue&type=template&id=89e573e6&lang=pug&"
import script from "./RoundsTableView.vue?vue&type=script&lang=js&"
export * from "./RoundsTableView.vue?vue&type=script&lang=js&"
import style0 from "./RoundsTableView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports